<!--
    描述：提现记录
    时间：2020/11/3
    Created by 张磊

    step1:
    编辑于      2021-1-14
    编辑人      王帅
    编辑内容:   提现参数 变更
-->
<template>
	<div class="h100 withdrawal-record">
	  <filter-layout
		@search="searchResult"
		@reset="reset"
		hasMore
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="流水号：" prop="bizOrderNo">
			  <el-input
				v-model="searchForm.bizOrderNo"
				placeholder="请输入提现流水号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="提现会员：" prop="bizUserId">
			  <el-input
				v-model="searchForm.bizUserId"
				placeholder="请输入"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="账户类型：" prop="bankCardPro">
			  <el-select
				v-model="searchForm.bankCardPro"
				placeholder="请选择提现状态"
				size="small"
			  >
				<el-option value="" label="全部"></el-option>
				<el-option :value="0" label="个人银行卡"></el-option>
				<el-option :value="1" label="企业对公账户"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="提现状态：" prop="status">
			  <el-select
				v-model="searchForm.status"
				placeholder="请选择提现状态"
				size="small"
			  >
				<el-option value="" label="全部"></el-option>
				<el-option :value="0" label="未到账"></el-option>
				<el-option :value="1" label="已到账"></el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="订单日期：" prop="dateRange">
			  <el-date-picker
				v-model="searchForm.dateRange"
				type="daterange"
				size="small"
				value-format="yyyy-MM-dd"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
			  >
			  </el-date-picker>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  合计提现：<span class="blue">{{ tablePage.total }}</span> 笔
			</div>
			<div class="toolbar">
			  <!-- <el-button
				type="primary"
				class="btn-blue ml10"
				size="small"
				@click="changeState"
			  >
				筛选
				<i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
				<i v-else class="el-icon-caret-top ml5"></i>
			  </el-button> -->
			  <el-button
				type="primary"
				class="btn-blue ml10"
				icon="el-icon-refresh"
				@click="reset"
				size="small"
			  ></el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow" ref="table">
			  <vxe-table
				ref="xTable"
				:data="tableData"
				highlight-current-row
				highlight-hover-row
				border
				height="100%"
				size="small"
				auto-resize
				resizable
				show-overflow="tooltip"
				show-header-overflow="tooltip"
			  >
				<vxe-table-column
				  type="seq"
				  title="序号"
				  width="55px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bizOrderNo"
				  title="提现流水号"
				  width="185px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="amount"
				  title="提现申请金额"
				  width="120px"
				  header-align="center"
				  align="right"
				>
				  <template v-slot="{ row }">
					<span>{{
					  row.amount ? parseFloat(row.amount).toFixed(2) : "0.00"
					}}</span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="actualAmount"
				  title="实际到账金额"
				  width="120px"
				  header-align="center"
				  align="right"
				>
				  <template v-slot="{ row }">
					<span>{{
					  row.actualAmount
						? parseFloat(row.actualAmount).toFixed(2)
						: "0.00"
					}}</span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="fee"
				  title="手续费"
				  width="90px"
				  header-align="center"
				  align="right"
				>
				  <template v-slot="{ row }">
					<span>{{
					  row.fee ? parseFloat(row.fee).toFixed(2) : "0.00"
					}}</span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="bizUseridName"
				  title="会员名称"
				  width="195px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bizUserid"
				  title="会员ID"
				  width="185px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bankName"
				  title="到账银行"
				  width="185px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span>{{
					  row.bankName && row.bankName !== "" ? row.bankName : "空"
					}}</span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="bankCardNo"
				  title="提现账户"
				  width="185px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bankCardPro"
				  title="账户类型"
				  width="150px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span v-if="row.bankCardPro == 0">个人银行卡</span>
					<span v-else-if="row.bankCardPro == 1">企业对公账户</span>
					<span v-else></span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="createUser"
				  title="实际操作人"
				  width="180px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="createDate"
				  title="订单日期"
				  width="180px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="summary"
				  title="摘要"
				  min-width="180px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span>{{
					  row.summary && row.summary !== "" ? row.summary : "空"
					}}</span>
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="status"
				  title="提现状态"
				  width="110px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span class="red-state" v-if="row.status == 0">未到账</span>
					<span class="blue-state" v-else-if="row.status == 1"
					  >已到账</span
					>
					<span v-else></span>
				  </template>
				</vxe-table-column>
				<vxe-table-column title="操作" width="8%" align="center">
				  <template v-slot="{ row }">
					<el-button
					  round
					  plain
					  class="table-btn"
					  type="primary"
					  size="small"
					  v-if="roleBtns.includes('withdrawalInfo')"
					  @click="showDetail(row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
				  </template>
				</vxe-table-column>
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="tablePage.currentPage"
				:page-size="tablePage.pageSize"
				:page-sizes="[10, 20, 50, 100]"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tablePage.total"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="h100 withdrawal-record bgc" v-else>
		<div class="money-detail">
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>提现流水号：</span>
			  <span>{{ currentRow.bizOrderNo }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>订单日期：</span>
			  <span>{{ currentRow.createDate }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>提现状态：</span>
			  <span
				:class="currentRow.status === 1 ? 'success-text' : 'error-text'"
				>{{ currentRow.status === 1 ? "已到帐" : "未到账" }}</span
			  >
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>提现会员： </span>
			  <span>{{ currentRow.bizUserid }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>支付方式： </span>
			  <span>{{ currentRow.payMethod }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>提现金额： </span>
			  <span>{{
				currentRow.amount
				  ? parseFloat(currentRow.amount).toFixed(2)
				  : "0.00"
			  }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>手续费： </span>
			  <span>{{
				currentRow.fee ? parseFloat(currentRow.fee).toFixed(2) : "0.00"
			  }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>行业代码： </span>
			  <span>{{ currentRow.industryCode }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>行业名称： </span>
			  <span>{{ currentRow.industryName }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>账户类型： </span>
			  <span>{{
				currentRow.bankCardPro === 1 ? "企业对公账户" : "个人银行卡"
			  }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>提现账户： </span>
			  <span>{{ currentRow.bankCardNo }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>账户集编号： </span>
			  <span>{{ currentRow.accountSetNo }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>访问中端类型：</span>
			  <span v-if="currentRow.source == 1">移动端</span>
			  <span v-else-if="currentRow.source == 2">PC端</span>
			  <span v-else>-</span>
			</el-col>
		  </el-row>
		  <el-row class="mb30" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>摘要： </span>
			  <span>{{ currentRow.summary }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>通商云订单号： </span>
			  <span>{{ currentRow.orderNo }}</span>
			</el-col>
		  </el-row>
		</div>
		<div class="footer text-center hidden">
		  <el-button class="btn cancel-btn" @click="goBack()">返回</el-button>
		</div>
	  </div>
	</div>
  </template>
<script>
import { selectWithdrawRecord } from "api/modules/paymentSettlement";
import { mapState } from "vuex";

export default {
	name: 'Withdrawal-record',
	props: {},
	data() {
		return {
			searchForm: {
				bizOrderNo: '', //流水号
				bizUserId: '', // 提现会员
				bankCardPro: '', // 账户类型
				status: '', //提现状态
				dateStart: '', // 起始时间
				dateEnd: '', // 截止日期
				dateRange: [], // 日期范围
			},

			tableData: [],
			tablePage: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			currentRow: {}, // 当前选择的行数据
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('record')) {
				this.searchForm = JSON.parse(this.$getSessionItem('record'))
				this.tablePage.currentPage = JSON.parse(
					this.$getSessionItem('record')
				).currentPage
				this.tablePage.pageSize = JSON.parse(
					this.$getSessionItem('record')
				).pageSize
				this.$removeSessionItem('record')
			}
		}

		this.selectPayDetailAll(true)
	},
	methods: {
		// 获取所有的流水数据
		selectPayDetailAll(isFirst) {
			let params = Object.assign({}, this.searchForm)
			params.current = this.tablePage.currentPage
			params.size = this.tablePage.pageSize
			params.createUser = this.userInfo.sname
			params.dateStart = params.dateRange[0]
			params.dateEnd = params.dateRange[1]
				? params.dateRange[1] + ' 23:59:59'
				: ''
			selectWithdrawRecord(params).then((d) => {
				if (d.operationCode == 1) {
					this.tableData = d.data.records
					this.tablePage.total = parseInt(d.data.total)

					// 刷新时 查看详细数据
					if (isFirst && this.$route.query.rowId) {
						let _row = this.tableData.find(
							(y) => y.id === this.$route.query.rowId
						)

						_row ? (this.currentRow = _row) : ''
					}
				}
			})
		},

		// 搜索
		searchResult() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.selectPayDetailAll()
		},

		// 重置
		reset() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.searchForm.bankCardPro = ''
			this.searchForm.status = ''
			this.searchForm.bizUserId = ''
			this.searchForm.bizOrderNo = ''
			this.searchForm.dateStart = ''
			this.searchForm.dateEnd = ''
			this.searchForm.dateRange = []
			this.selectPayDetailAll()
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tablePage.pageSize = size
			this.selectPayDetailAll()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tablePage.currentPage = cur
			this.selectPayDetailAll()
		},

		// 查看详情
		showDetail(data) {
			this.currentRow = data
			let params = Object.assign({}, this.searchForm)
			params.pageSize = this.tablePage.pageSize
			params.currentPage = this.tablePage.currentPage

			// 存值
			this.$setSessionItem('record', JSON.stringify(params))

			this.$router.push({
				path: '/withdrawal-record',
				query: {
					type: 'money-detail',
					rowId: data.id,
				},
			})
		},

		// 返回
		goBack() {
			this.$router.push({ path: '/withdrawal-record' })
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('app', {
			isBack: (state) => state.isBack,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
	},
}
</script>
<style lang="less" scoped>
.withdrawal-record {
	//.el-form {
	//	border-bottom: 1px solid #2671cc;
	//}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
	.btn-style {
		width: 80px;
		height: 32px;
	}
	.btn-blue {
		background-color: #2671cc !important;
		color: #fff;
	}
	.operation-header {
		display: block;
		line-height: 40px;
		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.number {
				padding-left: 10px;
				border-left: 4px solid #2671cc;
				height: 30px;
				line-height: 30px;
				span {
					color: #2671cc;
					font-size: 18px;
				}
			}
		}
	}
	.operation-container {
		height: calc(~'100% - 52px') !important;
	}
	/deep/ .vxe-cell--title {
		color: #202020;
		font-size: 14px;
		font-weight: normal;
	}
	.money-detail {
		font-size: 14px;
		padding: 30px 50px 0 50px;
		height: calc(~'100% - 50px');
	}
	.mb10 {
		margin-bottom: 10px !important;
	}

	.success-icon:before {
		content: '';
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: #13a919;
		border-radius: 50%;
		margin-right: 7px;
	}

	.error-icon:before {
		content: '';
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: #ff2313;
		border-radius: 50%;
		margin-right: 7px;
	}

	.success-text {
		color: #13a919;
		font-size: 16px;
		font-weight: 700;
	}

	.error-text {
		color: #ff2313;
		font-size: 16px;
		font-weight: 700;
	}
}
.bgc {
	background-color: #fff;
}
</style>

<style lang="less" scoped>
/deep/ .el-date-editor .el-range-separator {
	min-width: 25px;
}

</style>
